import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class MdsGraph extends AbstractScatterVisualization {
}
